export default "__VITE_ASSET__ARRsxUjS__"